var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 3.96V7H22.16V10.68H17.88C17.4533 13.2133 16.4 15.0533 14.72 16.2C13.0667 17.3467 10.56 17.92 7.2 17.92V20.04C7.2 21.2933 7.45333 22.28 7.96 23C8.49333 23.72 9.38667 24.08 10.64 24.08C11.84 24.08 12.7067 23.7467 13.24 23.08C13.7733 22.3867 14.04 21.3867 14.04 20.08H19.24C19.1867 22.7733 18.4267 24.84 16.96 26.28C15.4933 27.6933 13.4 28.4 10.68 28.4C7.85333 28.4 5.69333 27.64 4.2 26.12C2.70667 24.6 1.96 22.3867 1.96 19.48V14.16C4.81333 14.16 6.92 14.0933 8.28 13.96C9.64 13.8 10.6533 13.48 11.32 13C11.9867 12.52 12.4267 11.7467 12.64 10.68H0.68V7H12.84V3.96H0.68V0.0399976H22.16V3.96H18.12Z",
    fill: "#5F259F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.3df592e8a487c863aa6a554eb05c386f.svg";
export { ForwardRef as ReactComponent };